import { apiClient } from '_shared/dataFetching/apiConfig';
import { generateRandomNumber } from '_shared/utils/stringUtil';

export const flaggedService = {
  async getFlagged() {
    try {
      const url = `flagged?unique_id=${generateRandomNumber()}`;
      const res = await apiClient.get(url);
      if (!res.data) {
        throw new Error('No data received from server');
      }
      return res.data;
    } catch (error) {
      console.error('Error in flaggedService:', error);
      throw error;
    }
  }
};
